module.exports = __webpack_public_path__ + "static/img/phone.3112f98a.png";